import { i18nTranslationHelper } from '@/i18n'

export namespace Subtype {
  const t = i18nTranslationHelper.getTEnums
  export class Enum {
    static readonly SUBSCRIPTION = new Enum(1, 'SUBSCRIPTION', t('subtype.SUBSCRIPTION.label'), 1)
    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string,
      public readonly sequence: number
    ) {}

    is(subtype: Subtype.Enum | null): boolean {
      return this.id === subtype?.id
    }
  }

  export const getById = (id: number | null): Enum => {
    return Object.values(Subtype.Enum).find(subtype => subtype.id === id)
  }

  export const getByName = (name: string): Enum => {
    return Object.values(Subtype.Enum).find(type => type.name === name)
  }
}
